import Hidden from "@material-ui/core/Hidden";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import aboutIconGlyph from "Assets/newicons/app/profile/glyph/about-glyph-16px.svg";
import addressIconGlyph from "Assets/newicons/app/profile/glyph/address-glyph-16px.svg";
//import bankingIconGlyph from "Assets/newicons/app/profile/glyph/banking-glyph-16px.svg";
import biodataIconGlyph from "Assets/newicons/app/profile/glyph/biodata-glyph-16px.svg";
import contactIconGlyph from "Assets/newicons/app/profile/glyph/contact-glyph-16px.svg";
import dependantIconGlyph from "Assets/newicons/app/profile/glyph/dependents-glyph-16px.svg";
import impdatesIconGlyph from "Assets/newicons/app/profile/glyph/important-dates-glyph-16px.svg";
// import languageIconGlyph from "Assets/newicons/app/profile/glyph/language-glyph-16px.svg";
// import medicalIconGlyph from "Assets/newicons/app/profile/glyph/medical-glyph-16px.svg";
// import otherDataIconGlyph from "Assets/newicons/app/profile/glyph/other-data-glyph-16px.svg";
// import skillIconGlyph from "Assets/newicons/app/profile/glyph/skills-glyph-16px.svg";
import aboutIconOutline from "Assets/newicons/app/profile/outline/about-outline-16px.svg";
import addressIconOutline from "Assets/newicons/app/profile/outline/address-outline-16px.svg";
//import bankingIconOutline from "Assets/newicons/app/profile/outline/banking-outline-16px.svg";
import biodataIconOutline from "Assets/newicons/app/profile/outline/biodata-outline-16px.svg";
import contactIconOutline from "Assets/newicons/app/profile/outline/contact-outline-16px.svg";
import dependantIconOutline from "Assets/newicons/app/profile/outline/dependents-outline-16px.svg";
import impdatesIconOutline from "Assets/newicons/app/profile/outline/important-dates-outline-16px.svg";
// import languageIconOutline from "Assets/newicons/app/profile/outline/language-outline-16px.svg";
// import medicalIconOutline from "Assets/newicons/app/profile/outline/medical-outline-16px.svg";
// import otherDataIconOutline from "Assets/newicons/app/profile/outline/other-data-outline-16px.svg";
// import skillIconOutline from "Assets/newicons/app/profile/outline/skills-outline-16px.svg";
import get from "lodash/get";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../Actions/AxiosInstance";
import { profilePrivacyInfo } from "../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../Actions/LanguageAction";
import createstore from "../../../../store";
import "../Profile.css";
import EmpAbout from "./aboutEmp";
import EmpAddress from "./EmpAddress";
//import EmpBanking from "./EmpBanking";
import EmpContact from "./EmpContact";
//import EmpCustomData from "./EmpCustomData";
import EmpDependent from "./EmpDependent";
import EmpImportantDates from "./EmpImportantDates";
//import EmpLanguage from "./EmpLanguage";
//import EmpMedical from "./EmpMedical";
import EmpPersonal from "./EmpPersonal";
//import EmpSkill from "./EmpSkill";

class ProfileTabs extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      datarecived: false,
      tabId: 0,
      privacyData: [],
      myProfile: [
        { privacymenuid: 101, isprivacy: true },
        { privacymenuid: 102, isprivacy: true },
        { privacymenuid: 103, isprivacy: true },
        { privacymenuid: 104, isprivacy: true },
        { privacymenuid: 105, isprivacy: true },
        { privacymenuid: 106, isprivacy: true },
        { privacymenuid: 107, isprivacy: true },
        { privacymenuid: 108, isprivacy: true },
        { privacymenuid: 109, isprivacy: true },
        { privacymenuid: 110, isprivacy: true },
        { privacymenuid: 111, isprivacy: true },
        { privacymenuid: 112, isprivacy: true },
      ],
      colleagueProfile: [],
      colleagueid: "",
      hideButton: false,
      employeeid: "",
      privacyid: 101,
    };

    this.getSubTabs = this.getSubTabs.bind(this);
  }

  componentDidMount() {
    let employeeid;
    const { SubscriptionInfo } = createstore.getState();
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { colleagueid } = this.props.match.params;
    let hideButton;
    colleagueid && colleagueid != employeeid
      ? masterprofileid != 9
        ? (hideButton = true)
        : (hideButton = false)
      : (hideButton = false);
    this.setState({ colleagueid, hideButton, employeeid }, () => {
      this.GetPrivacyInfo();
    });
  }

  GetPrivacyInfo() {
    if (this.state.colleagueid) {
      const URL = `/users/empprofileprivacy/${this.state.colleagueid}`;
      instance
        .get(URL)
        .then((result) => {
          let colleagueProfile = [];
          result.data.result.length > 0
            ? (colleagueProfile = result.data.result)
            : (colleagueProfile = []);

          const nexttabs = colleagueProfile.filter(
            (tab) =>
              tab.privacymenuid != 100 &&
              tab.privacymenuid != 200 &&
              tab.privacymenuid != 300 &&
              tab.privacymenuid != 400,
          );
          const subroottabs = nexttabs.filter((tabs) => !tabs.isprivacy);

          this.setState({ colleagueProfile, subroottabs, datarecived: true });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      // this.props.profilePrivacyInfo(this.state.myProfile)
    }
  }

  CheckPrivacy(compId) {
    let result;
    if (!get(this.props, "AuthenticationAction.login", "")) {
      return true;
    }
    const { masterprofileid } = get(
      this.props,
      "AuthenticationAction.login",
      "",
    );
    if (
      this.state.colleagueid &&
      this.state.colleagueid != this.state.employeeid &&
      masterprofileid != 9
    ) {
      result = this.state.colleagueProfile;
      const info = result.find((x) => x.privacymenuid == compId);
      if (info) {
        // console.log('info2: ', info);
        if (info.isprivacy) {
          return false;
        }
        return true;
      }
      return false;
    }
    result = this.state.myProfile;
    const info = result.find((x) => x.privacymenuid == compId);
    // console.log('info: ', info);
    if (info.isprivacy) {
      return true;
    }
    return false;
  }

  handleChange(selectedId, privacyid) {
    this.setState({ tabId: selectedId, privacyid });
  }

  updatestrength(flag) {
    if (flag == true) {
      this.props.UpdateStrength(true);
    }
  }

  getSubTabs(tab, index) {
    switch (tab.privacymenuid) {
      case 101: {
        return (
          <MyTab
            label={<FormattedMessage id="TabAbout" defaultMessage="About" />}
            icon={
              this.state.tabId == 0 ? (
                <img src={aboutIconGlyph} style={{ marginBottom: 0, marginRight: 8 }} />
              ) : (
                <img src={aboutIconOutline} style={{ marginBottom: 0 , marginRight: 8 }} />
              )
            }
            onClick={this.handleChange.bind(this, index, 101)}
            className="var-tab-heading"
          />
        );
      }
      case 102: {
        return (
          <MyTab
            label={
              <FormattedMessage id="TabAddress" defaultMessage="Address" />
            }
            // icon={<Home />}
            icon={
              this.state.tabId == 1 ? (
                <img src={addressIconGlyph} style={{ marginBottom: 0 , marginRight: 8}} />
              ) : (
                <img src={addressIconOutline} style={{ marginBottom: 0, marginRight: 8 }} />
              )
            }
            onClick={this.handleChange.bind(this, index, 102)}
            className="var-tab-heading Address"
          />
        );
      }
      case 103: {
        return (
          <MyTab
            label={
              <FormattedMessage id="TabContact" defaultMessage="Contact" />
            }
            // icon={<PermContactCalendar />}
            icon={
              this.state.tabId == 2 ? (
                <img src={contactIconGlyph} style={{ marginBottom: 0 , marginRight: 8}} />
              ) : (
                <img src={contactIconOutline} style={{ marginBottom: 0 , marginRight: 8}} />
              )
            }
            onClick={this.handleChange.bind(this, index, 103)}
            className="var-tab-heading Contact"
          />
        );
      }
      case 104: {
        return (
          <MyTab
            label={
              <FormattedMessage id="TabPersonal1" defaultMessage="Biodata" />
            }
            // icon={<Note />}
            icon={
              this.state.tabId == 3 ? (
                <img src={biodataIconGlyph} style={{ marginBottom: 0 , marginRight: 8}} />
              ) : (
                <img src={biodataIconOutline} style={{ marginBottom: 0 , marginRight: 8}} />
              )
            }
            onClick={this.handleChange.bind(this, index, 104)}
            className="var-tab-heading Biodata"
          />
        );
      }
      case 105: {
        return (
          <MyTab
            label={
              <FormattedMessage
                id="TabImportantDates"
                defaultMessage="Important Dates"
              />
            }
            // icon={<Calendar />}
            icon={
              this.state.tabId == 4 ? (
                <img src={impdatesIconGlyph} style={{ marginBottom: 0, marginRight: 8 }} />
              ) : (
                <img src={impdatesIconOutline} style={{ marginBottom: 0 , marginRight: 8}} />
              )
            }
            onClick={this.handleChange.bind(this, index, 105)}
            className="var-tab-heading Dates"
          />
        );
      }
      case 106: {
        return (
          <MyTab
            label={
              <FormattedMessage
                id="TabDependents"
                defaultMessage="Dependents"
              />
            }
            // icon={<SupervisorAccount />}
            icon={
              this.state.tabId == 5 ? (
                <img src={dependantIconGlyph} style={{ marginBottom: 0, marginRight: 8 }} />
              ) : (
                <img src={dependantIconOutline} style={{ marginBottom: 0 , marginRight: 8}} />
              )
            }
            onClick={this.handleChange.bind(this, index, 106)}
            className="var-tab-heading Dependents"
          />
        );
      }
      // case 107: {
      //   return (
      //     <MyTab
      //       label={
      //         <FormattedMessage id="TabMedical" defaultMessage="Medical" />
      //       }
      //       // icon={<Hospital />}
      //       icon={
      //         this.state.tabId == 6 ? (
      //           <img src={medicalIconGlyph} style={{ marginBottom: 0 }} />
      //         ) : (
      //           <img src={medicalIconOutline} style={{ marginBottom: 0 }} />
      //         )
      //       }
      //       onClick={this.handleChange.bind(this, index, 107)}
      //       className="var-tab-heading Medical"
      //     />
      //   );
      // } // case 108: {
      // //   return <MyTab
      // //   label={<FormattedMessage id="TabIdentity" defaultMessage="Identity" />}
      // //   icon={<Identity />}
      // //   onClick={this.handleChange.bind(this, index, 108)}
      // //   className="var-tab-heading"
      // // />;
      // // }
      // case 109: {
      //   return (
      //     <MyTab
      //       label={
      //         <FormattedMessage id="TabBanking" defaultMessage="Banking" />
      //       }
      //       // icon={<Account />}
      //       icon={
      //         this.state.tabId == 7 ? (
      //           <img src={bankingIconGlyph} style={{ marginBottom: 0 }} />
      //         ) : (
      //           <img src={bankingIconOutline} style={{ marginBottom: 0 }} />
      //         )
      //       }
      //       onClick={this.handleChange.bind(this, index - 1, 109)}
      //       className="var-tab-heading Banking"
      //     />
      //   );
      // }
      // case 110: {
      //   return (
      //     <MyTab
      //       label={<FormattedMessage id="TabSkill" defaultMessage="Skills" />}
      //       // icon={<SkillIcon />}
      //       icon={
      //         this.state.tabId == 8 ? (
      //           <img src={skillIconGlyph} style={{ marginBottom: 0 }} />
      //         ) : (
      //           <img src={skillIconOutline} style={{ marginBottom: 0 }} />
      //         )
      //       }
      //       onClick={this.handleChange.bind(this, index - 1, 110)}
      //       className="var-tab-heading Skills"
      //     />
      //   );
      // }
      // case 111: {
      //   return (
      //     <MyTab
      //       label={
      //         <FormattedMessage id="TabLanguage" defaultMessage="Language" />
      //       }
      //       // icon={<Language />}
      //       icon={
      //         this.state.tabId == 9 ? (
      //           <img src={languageIconGlyph} style={{ marginBottom: 0 }} />
      //         ) : (
      //           <img src={languageIconOutline} style={{ marginBottom: 0 }} />
      //         )
      //       }
      //       onClick={this.handleChange.bind(this, index - 1, 111)}
      //       className="var-tab-heading Language"
      //     />
      //   );
      // }
      // case 112: {
      //   return (
      //     <MyTab
      //       label={
      //         <FormattedMessage
      //           id="TabCustomData"
      //           defaultMessage="Other Data"
      //         />
      //       }
      //       // icon={<AssignmentOutlinedIcon />}
      //       icon={
      //         this.state.tabId == 10 ? (
      //           <img src={otherDataIconGlyph} style={{ marginBottom: 0 }} />
      //         ) : (
      //           <img src={otherDataIconOutline} style={{ marginBottom: 0 }} />
      //         )
      //       }
      //       onClick={this.handleChange.bind(this, index - 1, 112)}
      //       className="var-tab-heading Other"
      //     />
      //   );
      // }
      default: {
        return;
      }
    }
  }

  render() {
    const { tabId, subroottabs, privacyid, hideButton, myProfile } = this.state;
    const language = this.props.Language.emppersonaltab;

    return (
      <IntlProvider locale="en" messages={language}>
        {/* {this.datarecived &&  */}
        <div
          className="vertical-tab-section"
          style={{
            display: "flex",
            overflowY: Hidden,
            paddingLeft: 0,
            paddingRight: 0,
          }}
        >
          <VerticalTabs
            value={tabId}
            indicatorColor="primary"
            textColor="primary"
            className="right-border width250 cursurpointer"
          >
            {hideButton
              ? subroottabs &&
                subroottabs.map((tab, index) => this.getSubTabs(tab, index))
              : myProfile &&
                myProfile.map((tab, index) => this.getSubTabs(tab, index))}
          </VerticalTabs>

          {this.CheckPrivacy(101) && privacyid && privacyid == 101 ? (
            <TabContainer>
              <EmpAbout
                editmode
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )}

          {this.CheckPrivacy(102) && privacyid && privacyid == 102 ? (
            <TabContainer>
              <EmpAddress
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )}
          {this.CheckPrivacy(103) && privacyid && privacyid == 103 ? (
            <TabContainer>
              <EmpContact
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )}
          {this.CheckPrivacy(104) && privacyid && privacyid == 104 ? (
            <TabContainer>
              <EmpPersonal
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )}
          {this.CheckPrivacy(105) && privacyid && privacyid == 105 ? (
            <TabContainer>
              <EmpImportantDates
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )}
          {this.CheckPrivacy(106) && privacyid && privacyid == 106 ? (
            <TabContainer>
              <EmpDependent
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )}
          {/* {this.CheckPrivacy(107) && privacyid && privacyid == 107 ? (
            <TabContainer>
              <EmpMedical
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )} */}
          {/* {this.CheckPrivacy(108) && privacyid && privacyid == 108 ? (
            <TabContainer>
              <EmpIdentityForm
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )} */}
          {/* {this.CheckPrivacy(109) && privacyid && privacyid == 109 ? (
            <TabContainer>
              <EmpBanking
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )}
          {this.CheckPrivacy(110) && privacyid && privacyid == 110 ? (
            <TabContainer>
              <EmpSkill
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )}
          {this.CheckPrivacy(111) && privacyid && privacyid == 111 ? (
            <TabContainer>
              <EmpLanguage
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )}
          {this.CheckPrivacy(112) && privacyid && privacyid == 112 ? (
            <TabContainer>
              <EmpCustomData
                {...this.props}
                UpdateStrength={this.updatestrength.bind(this)}
              />
            </TabContainer>
          ) : (
            ""
          )} */}
        </div>
      </IntlProvider>
    );
  }
}

const VerticalTabs = withStyles((theme) => ({
  flexContainer: {
    flexDirection: "column",
  },
  indicator: {
    display: "none",
  },
}))(Tabs);

const MyTab = withStyles((theme) => ({
  labelContainer: {
    padding: "6px 8px",
  },
  label: {
    // color: "rgba(0, 0, 0, 0.87)"
  },
  icon: {
    display: "inline-black",
  },
}))(Tab);

function TabContainer(props) {
  return (
    <Typography component="div" className="verticaltab-innercont">
      {props.children}
    </Typography>
  );
}

// ProfileTabs.propTypes = {
//     classes: PropTypes.object.isRequired,
//     theme: PropTypes.object.isRequired,
// };

const mapStateToProps = (state) => ({
  profilePrivacyInfoReducer: state.profilePrivacyInfoReducer,
  AuthenticationAction: state.AuthenticationAction,
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      profilePrivacyInfo: (data) => profilePrivacyInfo(data),
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProfileTabs);
